import { Paper, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { TrlFooterLink, TrlOuterModal } from '»components/atoms';
import { TrlModalBottomBar } from '»components/atoms/TrlModalBottomBar';
import { DialogStyled, PaperStyled } from '»components/atoms/TrlOuterModal';
import { TrlNewsContent } from '»components/molecules';
import { TrlDateFormatted } from '»utils/date';

import { HeadlineNewsContainer } from './TrlHeadlineNews.styles';

const getPaperComponent = (props, isMobile) =>
  isMobile ? <Paper {...props} /> : <PaperStyled {...props} />;

export const TrlHeadlineNews = ({ headlineNews }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  const handleOpenDetailsModal = (value) => {
    setOpenDetailsModal(value);
  };

  const {
    image,
    title,
    bodyShort,
    contentDate,
    sourceId,
    link,
    contSeq,
    fileName,
    fileDescr,
    visibleFile,
    video,
  } = headlineNews;

  const newsDate = `${TrlDateFormatted({ date: contentDate })} | ${sourceId}`;

  const openNewsLink = () => {
    window.open(link);
  };

  return (
    <HeadlineNewsContainer id="headlineNewsContainer">
      <DialogStyled
        fullScreen={isMobile}
        open={openDetailsModal}
        onClose={() => handleOpenDetailsModal(false)}
        PaperComponent={(props) =>
          getPaperComponent({ ...props, isNewsModal: true }, isMobile)
        }
      >
        {isMobile ? (
          <>
            <TrlNewsContent
              title={title}
              image={image}
              date={newsDate}
              contSeq={contSeq}
              fileName={fileName}
              fileDescr={fileDescr}
              visibleFile={visibleFile}
              video={video}
              isInModal
              isModalOpened={openDetailsModal}
              handleTitleClick={link ? openNewsLink : null}
            />
            <TrlModalBottomBar
              text="TRLT_UI-DASHBOARD"
              handleClick={() => {
                handleOpenDetailsModal(false);
              }}
            />
          </>
        ) : (
          <TrlOuterModal
            title="TRLT_UI-HIGHLIGHTS_NEWS"
            handleClose={() => handleOpenDetailsModal(false)}
            innerBackgroundColor={theme.palette.colors.newsBackground}
            isNewsModal
          >
            <TrlNewsContent
              title={title}
              image={image}
              date={newsDate}
              contSeq={contSeq}
              fileName={fileName}
              fileDescr={fileDescr}
              visibleFile={visibleFile}
              video={video}
              isInModal
              isModalOpened={openDetailsModal}
              handleTitleClick={link ? openNewsLink : null}
            />
          </TrlOuterModal>
        )}
      </DialogStyled>
      <TrlNewsContent
        title={title}
        image={image}
        bodyShort={bodyShort}
        date={newsDate}
        handleTitleClick={() => {
          handleOpenDetailsModal(true);
        }}
      />
      <TrlFooterLink
        navigateTo={() => handleOpenDetailsModal(true)}
        label="TRLT_UI-READ_FULL_ARTICLE"
        hasMarginTop
        hasBorder
        backgroundColor={theme.palette.colors.newsBackground}
      />
    </HeadlineNewsContainer>
  );
};

TrlHeadlineNews.propTypes = {
  headlineNews: PropTypes.object.isRequired,
};
